import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _promise = null;
const getFreshness = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = axios.get(`${API}/freshness`)
      .then((r) => { _cache = r.data; return _cache; })
      .catch(() => { _promise = null; return {}; });
  }
  return _promise;
};

const ago = (iso) => {
  const ms = Date.now() - new Date(iso).getTime();
  if (isNaN(ms)) return null;
  const mins = Math.floor(ms / 60000);
  if (mins < 2) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 31) return `${days}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

// Small "Updated Xh ago" pill. Dot: green <36h · amber <8d · red older.
const FreshnessStamp = ({ domain, className = "" }) => {
  const [ts, setTs] = useState(null);
  useEffect(() => {
    let on = true;
    if (domain) getFreshness().then((d) => { if (on) setTs(d?.[domain] || null); });
    return () => { on = false; };
  }, [domain]);
  if (!domain || !ts) return null;
  const label = ago(ts);
  if (!label) return null;
  const days = (Date.now() - new Date(ts).getTime()) / 86400000;
  const dot = days < 1.5 ? "bg-emerald-500" : days < 8 ? "bg-amber-500" : "bg-red-400";
  return (
    <span
      data-testid={`freshness-stamp-${domain}`}
      title={`Data last updated ${new Date(ts).toLocaleString()}`}
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-zinc-500 bg-white/70 border border-zinc-200 rounded-full px-2.5 py-1 ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      Updated {label}
    </span>
  );
};

export default FreshnessStamp;
